import { SelectC } from 'components'
import { useLoadConcepts } from 'modules/orders/components/LostProposalModal/useLoadConcepts'

export const SelectConcept = () => {
  const { data, isLoading } = useLoadConcepts({})

  return (
    <SelectC
      name="concept"
      label="Motivo"
      loading={isLoading}
      options={data?.data || []}
      getOptionLabel={(option: any) => option?.name}
    />
  )
}
